import React, { useState } from "react";
import { Visible } from "../../../../core/components";
import WhatsappView from "./WhatsappView";
import MarketPlacesView from "./MarketPlacesView";
import { requestTypes, tabOptions } from "../filter/constants";

const MainAiPricing = ({
  tab = "whatsapp",
  requestType,
  matchItem,
  productId,
  requestItem = null,
  fetchWhatsappData,
  fetchMarketplacesData,
  isNonMatch,
  setIsRemoved,
  isRemoved = false,
  discoverType,
  isOpportunityModal = false,
  hideImport = false,
  approveBlack = false,
}) => {
  return (
    <div className="main_container">
      <Visible
        when={
          (tab === "whatsapp" || tab === "similar_products") &&
          (matchItem?.matched_data || matchItem?.extracted_data)
        }
      >
        <WhatsappView
          requestType={requestType}
          matchItem={matchItem}
          productId={productId}
          requestItem={requestItem}
          fetchWhatsappData={fetchWhatsappData}
          isNonMatch={isNonMatch}
          setIsRemoved={setIsRemoved}
          isRemoved={isRemoved}
          isOpportunityModal={isOpportunityModal}
          hideImport={hideImport}
          approveBlack={approveBlack}
        />
      </Visible>
      <Visible when={tab === "discover"}>
        <WhatsappView
          requestType={requestTypes[0].id}
          matchItem={matchItem}
          productId={productId}
          requestItem={requestItem}
          fetchWhatsappData={fetchWhatsappData}
          isNonMatch={isNonMatch}
          setIsRemoved={setIsRemoved}
          isRemoved={isRemoved}
          hideImport={hideImport}
          approveBlack={approveBlack}
        />
      </Visible>
      <Visible when={tab === "marketplaces"}>
        <MarketPlacesView
          matchItem={matchItem}
          productId={productId}
          fetchMarketplacesData={fetchMarketplacesData}
          isNonMatch={isNonMatch}
          setIsRemoved={setIsRemoved}
          isRemoved={isRemoved}
        />
      </Visible>
    </div>
  );
};

export default MainAiPricing;
